import { showEvents } from "@/Configs/config";
import { Customers } from "@/Icons/Customers";
import { Infrastructure } from "@/Icons/Infrastructure";
import { Union } from "@/Icons/Union";
import { useConfig } from "@/api/hooks/useConfig";
import {
  NavHeaderTypeEnum,
  NavSectionInterface,
  navigationInterface,
} from "@/components/Sidebar/Sidebar.interface";
import { NavItem } from "@/components/Sidebar/components/NavItem";

import React from "react";

import { NavHeader } from "./NavHeader";

export const getNavigationInterface = ({
  isRealEstate = false,
  useExternalCRM = false,
}: {
  isRealEstate: boolean;
  useExternalCRM: boolean;
}): navigationInterface => {
  return {
    [NavHeaderTypeEnum.General]: {
      icon: Union,
      links: [
        {
          to: "/",
          name: "sidebarLabels:home",
        },
        isRealEstate && {
          to: "/reporting",
          name: "sidebarLabels:reporting",
        },
        showEvents && {
          to: "/events",
          name: "sidebarLabels:events",
        },
      ].filter((a) => !!a) as { to: string; name: string }[],
    },
    [NavHeaderTypeEnum.Customers]: {
      icon: Customers,
      links: [
        isRealEstate && {
          to: "/tenant/dashboard",
          name: "sidebarLabels:tenantFollowUp",
        },
        isRealEstate && {
          to: "/tenant/details",
          name: "drawerLabels:tenantDetails",
        },
        isRealEstate && {
          to: "/tenant/waste-streams",
          name: "statisticsLabels:tenantWasteTypes",
        },
        {
          to: "/customer/manage",
          name: "sidebarLabels:manageCustomers",
        },
        !isRealEstate &&
          useExternalCRM && {
            to: "/allocations",
            name: "sidebarLabels:allocations",
          },
        isRealEstate && {
          to: "/library",
          name: "sidebarLabels:library",
        },
      ].filter((a) => !!a) as { to: string; name: string }[],
    },
    [NavHeaderTypeEnum.Infrastructure]: {
      icon: Infrastructure,
      links: [
        {
          to: "/infrastructure/manage",
          name: "sidebarLabels:manageInfrastructure",
        },
      ].filter((a) => !!a) as { to: string; name: string }[],
    },
  };
};

export const NavSection: React.FC<NavSectionInterface> = ({ type }) => {
  const { isRealEstate, config } = useConfig();

  return (
    <li className="mb-5">
      <ul>
        <li className="mb-1.5">
          <NavHeader type={type} />
        </li>
        {getNavigationInterface({
          isRealEstate,
          useExternalCRM: !!config?.useExternalCRM,
        })[type].links.map(({ to, name }, index) => (
          <li key={index}>
            <NavItem to={to} name={name} />
          </li>
        ))}
      </ul>
    </li>
  );
};
